import { reactive, ref, nextTick } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e057ceee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-box"
};
const _hoisted_2 = {
  class: "filters"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "time-select"
};
const _hoisted_5 = {
  class: "select-item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select-title"
}, "时间段", -1));
const _hoisted_7 = {
  class: "select-content"
};
const _hoisted_8 = {
  class: "dimension-select"
};
const _hoisted_9 = {
  class: "select-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select-title"
}, "产品名", -1));
const _hoisted_11 = {
  class: "select-content"
};
const _hoisted_12 = {
  class: "appListPopover-content"
};
const _hoisted_13 = {
  class: "appListPopover-content-title"
};
const _hoisted_14 = {
  class: "inf-label"
};
const _hoisted_15 = {
  class: "inf-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_17 = {
  class: "appListPopover-content"
};
const _hoisted_18 = {
  class: "appListPopover-content-title"
};
const _hoisted_19 = {
  class: "inf-label"
};
const _hoisted_20 = {
  class: "inf-value"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_22 = {
  key: 0,
  class: "select-item"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select-title"
}, "国家", -1));
const _hoisted_24 = {
  class: "select-content"
};
const _hoisted_25 = {
  key: 1,
  class: "select-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select-title"
}, "版本", -1));
const _hoisted_27 = {
  class: "select-content"
};
const _hoisted_28 = {
  key: 2,
  class: "select-item"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select-title"
}, "支付渠道", -1));
const _hoisted_30 = {
  class: "select-content"
};
const _hoisted_31 = {
  class: "right"
};
import { onBeforeMount, computed } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
import { getAppList, getMonitorFiltes, getPayChnlByDbtIds } from '@/api/monitor';
import { detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPanel',
  props: {
    activeKey: String
  },
  emits: ['search', 'update:activeKey'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const tabKey = computed({
      get() {
        return props.activeKey;
      },
      set(val) {
        handleReset();
        emit('update:activeKey', val);
      }
    });
    const dateState = reactive({
      startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
      endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false // true 开启服务器时间
    });
    const compareDateState = reactive({
      startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
      endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false // true 开启服务器时间
    });
    const filters = reactive({
      period: 'day',
      dbtId: null,
      countrys: [],
      appVers: [],
      dbtIds: [],
      payChnls: []
    });
    const showVsDate = ref(false);
    const periodOptions = ref([{
      value: 'day',
      label: '天'
    }, {
      value: 'hour',
      label: '小时'
    }]);
    const handlePeriodChange = val => {
      if (val === 'hour') {
        showVsDate.value = false;
      }
    };
    const countryRef = ref(null);
    const verRef = ref(null);
    const payRef = ref(null);
    const productSelectRef = ref(null);
    const productSelectMultiRef = ref(null);
    const appList = ref([]);
    const countryList = ref([]);
    const appVerList = ref([]);
    const prodList = ref([]);
    const payChanelList = ref([]);
    const regionSelectRef = ref(null);
    const versionSelectRef = ref(null);
    const chanlSelectRef = ref(null);
    const handleProdChange = () => {
      if (tabKey.value === 'client') {
        var _countryRef$value, _verRef$value;
        filters.countrys = [];
        countryList.value = [];
        filters.appVers = [];
        appVerList.value = [];
        (_countryRef$value = countryRef.value) === null || _countryRef$value === void 0 || _countryRef$value.init();
        (_verRef$value = verRef.value) === null || _verRef$value === void 0 || _verRef$value.init();
        getFilters(filters.dbtId ? [filters.dbtId] : []);
      } else {
        var _payRef$value;
        filters.payChnls = [];
        (_payRef$value = payRef.value) === null || _payRef$value === void 0 || _payRef$value.init();
        getFilters(filters.dbtIds);
      }
    };
    // const handleChange = (key: any, val: any) => {
    //   filters[key] = val.map((v: any) => v.value)
    // }
    const getAppOptions = async () => {
      try {
        const {
          code,
          data
        } = await getAppList({
          pageNum: 1,
          pageSize: 2000
        });
        if (code === '0') {
          var _productSelectRef$val, _productSelectMultiRe;
          appList.value = data === null || data === void 0 ? void 0 : data.map(item => {
            var _item$extData;
            return {
              ...item,
              checked: false,
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
            };
          });
          prodList.value = data.map(item => {
            var _item$extData2;
            return {
              ...item,
              checked: false,
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              filePath: ((_item$extData2 = item.extData) === null || _item$extData2 === void 0 ? void 0 : _item$extData2.filePath) || '-'
            };
          });
          (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appList.value);
          (_productSelectMultiRe = productSelectMultiRef.value) === null || _productSelectMultiRe === void 0 || _productSelectMultiRe.initializeOptions(prodList.value);
        }
      } catch (e) {}
    };
    const filterLoading = ref(false);
    const getFilters = async dbtIds => {
      if (!(dbtIds !== null && dbtIds !== void 0 && dbtIds.length)) {
        return;
      }
      try {
        filterLoading.value = true;
        if (tabKey.value === 'client') {
          const {
            code,
            data
          } = await getMonitorFiltes({
            dbtIds,
            eventCodes: []
          });
          if (code === '0') {
            var _regionSelectRef$valu, _versionSelectRef$val;
            const {
              _country,
              _app_version
            } = data.options;
            countryList.value = _country.map(item => ({
              checked: false,
              label: item,
              value: item
            }));
            appVerList.value = _app_version.map(item => ({
              checked: false,
              label: item,
              value: item
            }));
            (_regionSelectRef$valu = regionSelectRef.value) === null || _regionSelectRef$valu === void 0 || _regionSelectRef$valu.initializeOptions(countryList.value);
            (_versionSelectRef$val = versionSelectRef.value) === null || _versionSelectRef$val === void 0 || _versionSelectRef$val.initializeOptions(appVerList.value);
          }
        } else {
          const {
            code,
            data
          } = await getPayChnlByDbtIds({
            dbtIds
          });
          if (code === '0') {
            var _chanlSelectRef$value;
            payChanelList.value = data.map(item => ({
              checked: false,
              label: item.payChnlName,
              value: item.payChnl
            }));
            (_chanlSelectRef$value = chanlSelectRef.value) === null || _chanlSelectRef$value === void 0 || _chanlSelectRef$value.initializeOptions(payChanelList.value);
          }
        }
      } catch (e) {} finally {
        filterLoading.value = false;
      }
    };
    const handleReset = () => {
      showVsDate.value = false;
      filters.period = 'day';
      filters.dbtId = null;
      filters.countrys = [];
      filters.appVers = [];
      filters.dbtIds = [];
      filters.payChnls = [];
      countryList.value = [];
      appVerList.value = [];
      payChanelList.value = [];
      prodList.value.forEach(item => {
        item.checked = false;
      });
    };
    const handleSearch = () => {
      const {
        appVers,
        countrys,
        dbtId,
        period,
        dbtIds,
        payChnls
      } = filters;
      if (tabKey.value === 'client') {
        if (!dbtId) {
          message.warning('请选择产品');
          return;
        }
        if (showVsDate.value && dayjs(dateState.startTime).diff(dayjs(dateState.endTime)) !== dayjs(compareDateState.startTime).diff(dayjs(compareDateState.endTime))) {
          message.warning('请选择天数相同的日期');
          return;
        }
      }
      const filter = {
        startDate: dayjs(dateState.startTime).format('YYYY-MM-DD'),
        endDate: dayjs(dateState.endTime).format('YYYY-MM-DD'),
        period
      };
      if (tabKey.value === 'client') {
        filter.appVers = appVers;
        filter.countrys = countrys;
        filter.dbtId = dbtId;
      }
      if (tabKey.value === 'server') {
        filter.payChnls = payChnls;
        filter.dbtIds = dbtIds;
      }
      if (showVsDate.value) {
        filter.compareTo = {
          startDate: dayjs(compareDateState.startTime).format('YYYY-MM-DD'),
          endDate: dayjs(compareDateState.endTime).format('YYYY-MM-DD')
        };
      }
      emit('search', filter);
    };
    const handleTabChange = val => {
      nextTick(() => {
        if (val === 'client') {
          var _productSelectRef$val2;
          (_productSelectRef$val2 = productSelectRef.value) === null || _productSelectRef$val2 === void 0 || _productSelectRef$val2.initializeOptions(appList.value);
        } else {
          var _productSelectMultiRe2;
          (_productSelectMultiRe2 = productSelectMultiRef.value) === null || _productSelectMultiRe2 === void 0 || _productSelectMultiRe2.initializeOptions(prodList.value);
        }
      });
    };
    onBeforeMount(() => {
      getAppOptions();
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tabs, {
        activeKey: _unref(tabKey),
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => _isRef(tabKey) ? tabKey.value = $event : null),
        onChange: handleTabChange
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "client",
          tab: "客户端"
        }), _createVNode(_component_a_tab_pane, {
          key: "server",
          tab: "服务端"
        })]),
        _: 1
      }, 8, ["activeKey"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_space, null, {
        default: _withCtx(() => [_createVNode(DbtDatePicker, {
          "show-use-server-time": false,
          "show-header": false,
          "show-dynamic": false,
          startTime: dateState.startTime,
          "onUpdate:startTime": _cache[1] || (_cache[1] = $event => dateState.startTime = $event),
          endTime: dateState.endTime,
          "onUpdate:endTime": _cache[2] || (_cache[2] = $event => dateState.endTime = $event),
          recentDay: dateState.recentDay,
          "onUpdate:recentDay": _cache[3] || (_cache[3] = $event => dateState.recentDay = $event),
          dynamic: dateState.dynamic,
          "onUpdate:dynamic": _cache[4] || (_cache[4] = $event => dateState.dynamic = $event),
          fromDayToDay: dateState.fromDayToDay,
          "onUpdate:fromDayToDay": _cache[5] || (_cache[5] = $event => dateState.fromDayToDay = $event),
          useServerTime: dateState.useServerTime,
          "onUpdate:useServerTime": _cache[6] || (_cache[6] = $event => dateState.useServerTime = $event),
          position: "bottomLeft"
        }, null, 8, ["startTime", "endTime", "recentDay", "dynamic", "fromDayToDay", "useServerTime"]), _createVNode(_component_a_select, {
          style: {
            "width": "100px"
          },
          onChange: handlePeriodChange,
          value: filters.period,
          "onUpdate:value": _cache[7] || (_cache[7] = $event => filters.period = $event),
          options: periodOptions.value
        }, null, 8, ["value", "options"]), filters.period === 'day' ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          "icon-class": "vs",
          class: "vs-icon",
          onClick: _cache[8] || (_cache[8] = $event => showVsDate.value = !showVsDate.value)
        })) : _createCommentVNode("", true), filters.period === 'day' && showVsDate.value ? (_openBlock(), _createBlock(DbtDatePicker, {
          key: 1,
          "show-use-server-time": false,
          "show-header": false,
          "show-dynamic": false,
          startTime: compareDateState.startTime,
          "onUpdate:startTime": _cache[9] || (_cache[9] = $event => compareDateState.startTime = $event),
          endTime: compareDateState.endTime,
          "onUpdate:endTime": _cache[10] || (_cache[10] = $event => compareDateState.endTime = $event),
          recentDay: compareDateState.recentDay,
          "onUpdate:recentDay": _cache[11] || (_cache[11] = $event => compareDateState.recentDay = $event),
          dynamic: compareDateState.dynamic,
          "onUpdate:dynamic": _cache[12] || (_cache[12] = $event => compareDateState.dynamic = $event),
          fromDayToDay: compareDateState.fromDayToDay,
          "onUpdate:fromDayToDay": _cache[13] || (_cache[13] = $event => compareDateState.fromDayToDay = $event),
          useServerTime: compareDateState.useServerTime,
          "onUpdate:useServerTime": _cache[14] || (_cache[14] = $event => compareDateState.useServerTime = $event),
          position: "bottomLeft"
        }, null, 8, ["startTime", "endTime", "recentDay", "dynamic", "fromDayToDay", "useServerTime"])) : _createCommentVNode("", true)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_withDirectives(_createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: filters.dbtId,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => filters.dbtId = $event),
        multiple: false,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: "100%",
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: handleProdChange,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_15, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_16]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"]), [[_vShow, _unref(tabKey) === 'client']]), _withDirectives(_createVNode(_unref(ProductSelect), {
        ref_key: "productSelectMultiRef",
        ref: productSelectMultiRef,
        modelValue: filters.dbtIds,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => filters.dbtIds = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: handleProdChange
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_19, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_20, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_21]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"]), [[_vShow, _unref(tabKey) === 'server']])])]), _unref(tabKey) === 'client' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createVNode(_unref(ProductSelect), {
        ref_key: "regionSelectRef",
        ref: regionSelectRef,
        modelValue: filters.countrys,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => filters.countrys = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择"
      }, null, 8, ["modelValue", "search-fields"])])])) : _createCommentVNode("", true), _unref(tabKey) === 'client' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createVNode(_unref(ProductSelect), {
        ref_key: "versionSelectRef",
        ref: versionSelectRef,
        modelValue: filters.appVers,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => filters.appVers = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择"
      }, null, 8, ["modelValue", "search-fields"])])])) : _createCommentVNode("", true), _unref(tabKey) === 'server' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [_createVNode(_unref(ProductSelect), {
        ref_key: "chanlSelectRef",
        ref: chanlSelectRef,
        modelValue: filters.payChnls,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => filters.payChnls = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择"
      }, null, 8, ["modelValue", "search-fields"])])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_a_space, null, {
        default: _withCtx(() => [_createVNode(_component_a_button, {
          onClick: handleReset
        }, {
          default: _withCtx(() => [_createTextVNode("重置")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          onClick: handleSearch
        }, {
          default: _withCtx(() => [_createTextVNode("搜索")]),
          _: 1
        })]),
        _: 1
      })])])]);
    };
  }
});